import React from 'react';
import PropTypes from 'prop-types';
import { formatDate } from '../../../helpers';
import { TimingRaceWrapper, TimingLabel } from './styles';
import * as raceStatus from '../../../constants';

const TimingRace = ({
  status, dictionary, isLive, startDate,
  startTime, justify, actions
}) => {
  const isEnded = () => (status === raceStatus.FINISHED);

  const timingCountDown = () => {
    const start = new Date(startDate).getTime();
    const now = Date.now();
    const timeDiff = start - now;
    const seconds = Math.floor(timeDiff / 1000);
    const minute = Math.floor(seconds / 60);
    if ((timeDiff <= 3600000) && (minute > 0)) {
      return `-${minute}'`;
    } else {
      return formatDate(startDate, actions);
    }
  };

  const calcMinute = () => {
    const start = new Date(startTime).getTime();
    const now = Date.now();
    const timeDiff = now - start;
    const seconds = Math.floor(timeDiff / 1000);
    const minute = Math.floor(seconds / 60);
    return `${minute + 1}'`;
  };

  const timingLabel = () => {
    switch (status) {
      case raceStatus.ABORTED:
      case raceStatus.FINISHED:
      case raceStatus.TOAPPROVAL:
      case raceStatus.TBD:
        return dictionary.competitionTable.gpStatus[status];
      case raceStatus.NOTSTARTED:
        return timingCountDown();
      case raceStatus.ON_TRACK:
        return calcMinute();
      default:
        return '';
    }
  };
  return (
    <TimingRaceWrapper justify={justify}>
      <TimingLabel
        color={isLive ? 'liveColor' : 'black'}
        font={(isLive || isEnded()) ? 'narrowMedium' : 'narrowRegular'}
      >
        {timingLabel()}
      </TimingLabel>
    </TimingRaceWrapper>
  );
};

TimingRace.propTypes = {
  status: PropTypes.any,
  dictionary: PropTypes.any,
  isLive: PropTypes.any,
  startDate: PropTypes.any,
  startTime: PropTypes.any,
  justify: PropTypes.any,
  actions: PropTypes.any,
};

export default TimingRace;
